export default "/_next/static/images/97efaa84598aaaa98e68845f75019689.svg";